// export const imageDomain = 'http://poponit.s3.amazonaws.com/photos/';

export const imageDomain = 'https://d2as2yj4fzvxx4.cloudfront.net/';

export const placeholderImage = 'https://via.placeholder.com/300';

export const isProd = process.env.NODE_ENV !== 'development';
